import React from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { IoIosAlert } from 'react-icons/io';

import './erro.css';

export function DialogErroBlacklistCadastrar({ visible, closeDialog, messageHeader }) {
    const footer = (
        <div>
            <Button label="Ok" icon="pi pi-check" onClick={closeDialog} />
        </div>
    );

    return (
        <Dialog header={messageHeader} footer={footer} visible={visible} style={{ width: '50vw' }} modal onHide={closeDialog}>
            <div className="dialog-content">
                <IoIosAlert color="red" fontSize={50} />
                <h1>Este telefone está cadastrado em outros contratos com CPFs diferentes.</h1>
            </div>
        </Dialog>
    );
}

export function DialogErroBlacklistAceite({ visible, closeDialog, messageHeader }) {
    const footer = (
        <div>
            <Button label="Ok" icon="pi pi-check" onClick={closeDialog} />
        </div>
    );

    return (
        <Dialog header={messageHeader} footer={footer} visible={visible} style={{ width: '50vw' }} modal onHide={closeDialog}>
            <div className="dialog-content">
                <IoIosAlert color="red" fontSize={50} />
                <h1>Este telefone está cadastrado em mais de 3 contratos com CPFs diferentes e será encaminhado para análise.</h1>
            </div>
        </Dialog>
    );
}
